var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50033 2.5H17.5003C17.9606 2.5 18.3337 2.8731 18.3337 3.33333V16.6667C18.3337 17.1269 17.9606 17.5 17.5003 17.5H2.50033C2.04009 17.5 1.66699 17.1269 1.66699 16.6667V3.33333C1.66699 2.8731 2.04009 2.5 2.50033 2.5ZM16.667 6.0316L10.0602 11.9483L3.33366 6.01328V15.8333H16.667V6.0316ZM3.75988 4.16667L10.0519 9.71833L16.2512 4.16667H3.75988Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOrderIcon);
export default __webpack_public_path__ + "static/media/emailOrderIcon.829942a9fa14b32c0d24696d7882adc9.svg";
export { ForwardRef as ReactComponent };